import React, { Component } from 'react';

//componentes
import Premedia from './premedia'

class Index extends Component {

    render(){
        return(
            <div>
                <Premedia />
            </div>
        );
    }

}
export default Index;